export default __webpack_public_path__ + "static/char-v-20-jam-e065237d6122a594ebb58f6c608badd1.mp4";